import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { setContext } from '@apollo/client/link/context';
import { BrowserPersistence } from '@magento/peregrine/lib/util';
var storage = new BrowserPersistence();
export default function createAuthLink() {
  return setContext(function (_, _ref) {
    var headers = _ref.headers;
    // get the authentication token from local storage if it exists.
    var token = storage.getItem('signin_token'); // return the headers to the context so httpLink can read them

    return {
      headers: _objectSpread({}, headers, {
        authorization: token ? "Bearer ".concat(token) : ''
      })
    };
  });
}